import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  formContainer: {
    height: 'initial',
    overflowY: 'hidden',
    [theme.breakpoints.down('md')]: {
      height: 'initial',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'initial',
    },
  },
  footerText: {
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '1.75rem',
    color: '#2C1482',
    maxWidth: '650px',
    margin: '0px auto 1rem auto',
    padding: '0px 16px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '24px',
      padding: '0px',
      margin: '2rem auto',
    },
  },
  buttonFooterTitle: {
    marginTop: '10px',
    color: '#176BCD',
    textAlign: 'center',
    fontFamily: '"Montserrat", "sans-serif"',
    fontSize: '14px',
    fontWeight: '600',
  },
  buttonContainer: {
    textAlign: 'center',
    marginTop: '25px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '50px',
    },
  },
  buttonInmobiliariaContainer: {
    textAlign: 'center',
    marginTop: '0px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '0px',
    },
  },
  button: {
    background: '#FFA500',
    borderRadius: '60px',
    textTransform: 'none',
    fontWeight: 700,
    color: '#000',
    fontFamily: '"Montserrat", "sans-serif"',
    fontSize: '16px',
    lineHeight: '1.2rem',
    padding: '16px 40px',
    '&:hover': {
      background: '#FFA500',
      opacity: '0.6',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '20px',
      padding: '16px 60px',
    },
  },
  container: {
    [theme.breakpoints.down('md')]: {
    },
    [theme.breakpoints.down('xs')]: {
    },
  },
  containerMultiOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
    },
    [theme.breakpoints.down('xs')]: {
    },
  },
  header: {
    maxWidth: '900px !important',
  },
  whatss: {
    right: '8%',
    bottom: '40px',
    [theme.breakpoints.down('xs')]: {
      bottom: '60px',
      right: '4%',
      width: '40px',
      height: '40px',
    },
  },
  FactorajeDataContainer: {
    margin: '1rem auto 1rem auto',
    maxWidth: '600px',
    padding: '0 15px 0 15px',
    [theme.breakpoints.up('sm')]: {
      padding: '0',
    },
  },
  whats: {
    textAlign: 'center',
    display: 'block',
    fontWeight: '700',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: '#2C1482',
    fontFamily: 'Montserrat, sans-serif',
    padding: '0 16px',
    marginTop: '40px',
    textDecoration: 'none',
    [theme.breakpoints.up('sm')]: {
      marginTop: '120px',
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      padding: '0 0px',
    },
  },
  messageWhats: {
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    color: '#2C1482',
    fontFamily: 'Montserrat, sans-serif',
    padding: '0 16px',
    marginTop: '30px',
    marginBottom: '30px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem',
      padding: '0 0px',
      marginTop: '45px',
      marginBottom: '25px',
    },
  },
  componentTitle: {
    textAlign: 'center',
    fontWeight: '700',
    fontSize: '15px',
    lineHeight: '1.25rem',
    color: '#176BCD',
    fontFamily: 'Montserrat, sans-serif',
    padding: '0 16px',
    marginTop: '40px',
    [theme.breakpoints.up('sm')]: {
      marginTop: '120px',
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      padding: '0 0px',
    },
  },
  buttonSimulator: {
    cursor: 'pointer',
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '1rem',
    lineHeight: '1.7rem',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2DBDB',
    borderRadius: '5px',
    color: '#444345',
    fontFamily: 'Montserrat, sans-serif',
    padding: '6px 16px',
    marginTop: '40px',
    textTransform: 'none',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.50rem',
      lineHeight: '2.5rem',
      padding: '0 20px',
    },
  },
  buttonMultiOptions: {
    cursor: 'pointer',
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '1rem',
    lineHeight: '1.7rem',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2DBDB',
    borderRadius: '5px',
    color: '#444345',
    fontFamily: 'Montserrat, sans-serif',
    padding: '10px 16px',
    margin: '10px 0',
    flex: '1',
    width: '100%',
    textTransform: 'none',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.20rem',
      lineHeight: '2.5rem',
      padding: '0 20px',
    },
  },
  buttonExtraOptions: {
    fontSize: '0.8rem',
    fontWeight: 700,
    fontFamily: 'Montserrat, sans-serif',
    textAlign: 'center',
    lineHeight: '1.5rem',
    padding: '10px 24px',
    color: '#2C1482',
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: '#2C1482',
      backgroundColor: 'transparent',
    },
    '&:active': {
      color: '#2C1482',
      backgroundColor: 'transparent',
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },
  containerExtraOptions: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    textAlign: 'center',
  },
  containerBanks: {
    maxWidth: '850px',
    width: '100%',
    margin: '0 auto',
    marginTop: '50px',
  },
  title: {
    color: '#2C1482',
    maxWidth: '850px',
    margin: '0 auto',
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: '2.5rem',
    marginTop: '50px',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem',
      paddingLeft: '5%',
      paddingRight: '5%',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
    },
  },
  subtContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '20px',
    paddingTop: '35px',
  },
  subtitle: {
    fontSize: '18px',
    lineHeight: '1.25rem',
    fontFamily: '"Montserrat", "sans-serif"',
    color: '#176BCD',
    fontWeight: '600',
    textAlign: 'center',
    maxWidth: '730px',
  },
  extraInputClassName: {
    borderColor: 'gray',
  },
  inputField: {
    backgroundColor: '#F9F9F9 !important',
  },
}));
